export const UNIT_SYSTEM = {
  METRIC: "metric",
  IMPERIAL: "imperial",
} as const;

export const UNIT_LABELS = {
  [UNIT_SYSTEM.METRIC]: { length: "mm", weight: "kg" },
  [UNIT_SYSTEM.IMPERIAL]: { length: "in", weight: "lb" },
} as const;

export const LENGTH_UNIT_OPTIONS = [
  { value: "mm", label: "Millimeters" },
  { value: "m", label: "Meters" },
  { value: "ft", label: "Foots" },
  { value: "inch", label: "Inches" },
] as const;

export const WEIGHT_UNIT_OPTIONS = [
  { value: "kg", label: "Kilograms" },
  { value: "lb", label: "Pounds" },
] as const;

export const ROLL_PLACEMENT = {
  SQUARE: 4,
  HEXAGON: 6,
} as const;
